import type ExtensionAPI from 'echarts/lib/core/ExtensionAPI';
import type { graphic } from 'echarts/core';
import type { EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import type GlobalModel from 'echarts/lib/model/Global';
import type SliderZoomView from 'echarts/lib/component/dataZoom/SliderZoomView';
import type { Displayables, PointLike } from './type';
import { getSliderDataZoomModels } from './helper';
import { isValidNumericValue } from './util';
import { normalizeToArray } from '../../../util/utils';

function parseDataZoomBorderRadius(ecIns: ExtensionAPI) {
  const sliderModels = getSliderDataZoomModels(ecIns);
  sliderModels.forEach(model => {
    const dvBorderRadius = model.get('borderRadius');
    const dataZoomView = ecIns.getViewOfComponentModel(model) as SliderZoomView;

    if (!isValidNumericValue(dvBorderRadius)) {
      return;
    }

    if (!normalizeToArray(dvBorderRadius).every(r => r >= 0)) {
      return;
    }

    // 背景圆角 能改上半两个圆角
    // @ts-ignore
    ((dataZoomView?._displayables as Displayables)?.sliderGroup?.childAt(0) as graphic.Rect)?.attr({
      shape: {
        r: dvBorderRadius
      }
    });

    /**
     * dataZoom的选中区间框 同步调整圆角
     * 用于海外主题下的datazoom 滑块、选中框、背景对齐
     * @see git提交98350b155c4ca69c207def0654f1427422ac9f91
     *  */
    // @ts-ignore
    (dataZoomView?._displayables as Displayables)?.filler?.attr({
      shape: {
        r: dvBorderRadius
      }
    });

    // 修改数据背景圆角,用于下半两个圆角
    // @ts-ignore
    (dataZoomView?._displayables as Displayables)?.dataShadowSegs?.forEach(group => {
      group.getClipPath().attr({
        shape: {
          r: dvBorderRadius
        }
      });
    });

    // 不再用echarts内部的位置算法（因为他的计算包含了偏移和缩放），直接使用原始配置的数据
    // @ts-ignore
    if ((dataZoomView?._location as PointLike)?.x) {
      dataZoomView?.group?.attr({
        // @ts-ignore
        x: (dataZoomView?._location as PointLike).x
      });
    }
  });
}

export function install(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('afterupdate', (ecModel: GlobalModel, ecIns: ExtensionAPI) => {
    parseDataZoomBorderRadius(ecIns);
  });
}
